const prefix = "home/";

const type = {
  INC_COUNT: prefix + "inc_count",
  CHANGE_COLOR: prefix + "change_color",
  LOGIN: prefix + "login"
};

const action = {
  incCount: number => {
    return {
      type: type.INC_COUNT,
      payload: {
        number
      }
    };
  },
  changeColor: color => {
    return {
      type: type.CHANGE_COLOR,
      payload: {
        color
      }
    };
  },
  login: isLogin => {
    return {
      type: type.LOGIN,
      payload: {
        isLogin
      }
    };
  }
};

export default {
  type,
  action
};
